import { BaseEntity } from 'yt-ng-framework';


export class SistRadnihMestaView extends BaseEntity {
    constructor() {
        super();
    }
    RadnoMesto: string = null;
    OrgJed: string = null;
    BrojIzvrsilaca: string = null;


    Deserialize(input: any) {
        this.ID = input.ID;
        this.RadnoMesto = input.RadnoMesto;
        this.OrgJed = input.OrgJed;
        this.BrojIzvrsilaca = input.broj_izvrsilaca;
        return this;
    }

    Serialize(input: SistRadnihMestaView) {
        return input;
    }
}
